export interface RouteMetaItem {
  path: string;
  pathMatch?: "exact" | "prefix";
  titleKey?: string;
  title?: string;
  descriptionKey?: string;
  ogImage?: string;
}

const PUBLIC_ROUTE_META: RouteMetaItem[] = [
  {
    path: "/",
    pathMatch: "exact",
    titleKey: "home.nav.inicio",
    descriptionKey: "home.servicos.subtitle",
  },
  {
    path: "/sobre",
    pathMatch: "exact",
    titleKey: "home.hero.breadcrumb.sobre",
    descriptionKey: "home.sobre.grupoAgnes",
  },
  {
    path: "/servicos",
    pathMatch: "exact",
    titleKey: "home.servicos.bannerTitle",
    descriptionKey: "home.servicos.subtitle",
  },
  {
    path: "/login",
    pathMatch: "exact",
    titleKey: "auth.login.title",
    descriptionKey: "auth.login.subtitle",
  },
  { path: "/register", pathMatch: "exact", titleKey: "auth.register.title" },
  {
    path: "/forgot-password",
    pathMatch: "exact",
    titleKey: "auth.forgotPassword.title",
    descriptionKey: "auth.forgotPassword.subTitle",
  },
  {
    path: "/forgot-password-submit",
    pathMatch: "exact",
    titleKey: "auth.forgotPasswordSubmit.title",
    descriptionKey: "auth.forgotPasswordSubmit.subTitle",
  },
  {
    path: "/vaga",
    pathMatch: "prefix",
    titleKey: "home.hero.breadcrumb.vaga",
    descriptionKey: "home.vagas.filtro.pesquisar",
  },
  {
    path: "/vagas",
    pathMatch: "prefix",
    titleKey: "home.hero.breadcrumb.vaga",
    descriptionKey: "home.vagas.filtro.pesquisar",
  },
  {
    path: "/under-construction",
    pathMatch: "exact",
    titleKey: "common.errors.underConstructions.title",
    descriptionKey: "common.errors.underConstructions.subTitle",
  },
  {
    path: "/403",
    pathMatch: "exact",
    titleKey: "common.errors.unexpected.title",
    descriptionKey: "common.errors.unexpected.subTitle",
  },
  {
    path: "/404",
    pathMatch: "exact",
    titleKey: "common.errors.notFound.title",
    descriptionKey: "common.errors.notFound.subTitle",
  },
];

const APP_ROUTE_META: RouteMetaItem[] = [
  {
    path: "/candidato/profile/password",
    pathMatch: "exact",
    titleKey: "profile.password.title",
  },
  {
    path: "/candidato/profile/information",
    pathMatch: "exact",
    titleKey: "profile.info.title",
  },
  {
    path: "/candidato/profile",
    pathMatch: "exact",
    titleKey: "profile.completion.title",
  },
  {
    path: "/candidato/vagas",
    pathMatch: "exact",
    titleKey: "vagasManagement.toolbar.title",
  },
  { path: "/candidato/help", pathMatch: "exact", titleKey: "help.title" },
  { path: "/candidato/faq", pathMatch: "exact", titleKey: "faq.title" },
  {
    path: "/candidato/calendar",
    pathMatch: "exact",
    titleKey: "calendar.title",
  },
  {
    path: "/candidato/cadastro",
    pathMatch: "exact",
    titleKey: "singupform.title",
  },
  {
    path: "/candidato/processo",
    pathMatch: "exact",
    title: "Processo Seletivo",
  },
  { path: "/candidato/meus-dados", pathMatch: "exact", title: "Meus Dados" },
  { path: "/candidato", pathMatch: "prefix", titleKey: "dashboard.title" },
  {
    path: "/empresa/login",
    pathMatch: "exact",
    titleKey: "empresa.login.title",
  },
  {
    path: "/empresa",
    pathMatch: "prefix",
    titleKey: "empresa.inicio.title",
  },
];

export const ROUTE_META: RouteMetaItem[] = [
  ...PUBLIC_ROUTE_META,
  ...APP_ROUTE_META,
];

export function getDefaultOgImage(): string {
  if (typeof window === "undefined") return "";
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return `${window.location.origin}${base}/og-default.png`;
}

const BASE_PATH = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

export function findRouteMeta(pathname: string): RouteMetaItem | undefined {
  let path = pathname.replace(/\/$/, "") || "/";
  if (BASE_PATH && path.startsWith(BASE_PATH)) {
    path = path.slice(BASE_PATH.length) || "/";
  }
  const normalized = path || "/";
  for (const item of ROUTE_META) {
    if (item.pathMatch === "prefix") {
      if (normalized === item.path || normalized.startsWith(item.path + "/"))
        return item;
    } else {
      const exact = item.path === "/" ? "/" : item.path.replace(/\/$/, "");
      if (
        normalized === exact ||
        (exact === "/" && (normalized === "" || normalized === "/"))
      )
        return item;
    }
  }
  return undefined;
}
